import React from 'react';

type MenuProps = { onClick?: () => void };

export default class MenuHamburger extends React.Component<MenuProps> {
  private nav: React.RefObject<HTMLDivElement>;

  constructor(props: MenuProps) {
    super(props);
    this.nav = React.createRef<HTMLDivElement>();
  }

  toggleClass(): void {
    this.nav.current?.classList.toggle('open');
    if (this.props.onClick) this.props.onClick();
  }

  close(): void {
    this.nav.current?.classList.remove('open');
  }

  render(): JSX.Element {
    return (
      <div id="nav-icon2" onClick={() => this.toggleClass()} className="nav-icon" ref={this.nav}>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    );
  }
}
